import { SpotRecentBaseIcon } from '@tableau/icons/SpotRecentBaseIcon';
import React from 'react';
import _ from 'underscore';

import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';
import { Location } from '~commonInfra/utils/Location';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { ProjectDefinition } from '~src/projects/components/contentDefinitions/ProjectDefinition';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { ExplorerEmptyStateProps } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerEmpyState';
import { CompactSpaceHeaderContent } from '~src/spacesPlatform/components/header/CompactSpaceHeaderContent';
import { SpaceHeaderContent } from '~src/spacesPlatform/components/header/SpaceHeaderContent';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { Messages } from '../../codegen/Localize';

export interface RecentsSpaceStateProps {
  readonly urls: SpacesSiteUrls;
}

export interface RecentsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export interface RecentsSpaceOwnProps {
  readonly siteName: string;
}

export type RecentsSpaceProps = RecentsSpaceStateProps & RecentsSpaceDispatchProps & RecentsSpaceOwnProps;

export class RecentsSpace extends React.PureComponent<RecentsSpaceProps> {
  public componentDidMount() {
    this.props.requestSpaceContents();
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.recentsBrowserTitle() });
  }

  public componentDidUpdate(prevProps: RecentsSpaceProps) {
    if (!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  public render(): JSX.Element {
    return (
      <div className={SpaceContainerStyles.SpaceContainer}>
        {
          FeatureFlags.compactHeaderEnabled ?
            <CompactSpaceHeaderContent headerText={Messages.recentsBrowserTitle()} />
            : <div className={SpaceContainerStyles.MastheadArea}>
              <SpaceHeaderContent headerText={Messages.recentsBrowserTitle()} />
            </div>
        }
        <div className={SpaceContainerStyles.SubplaceArea}>
          <ConnectedExplorer
            supportedDisplayModes={ProjectDefinition.supportedDisplayModes}
            emptyStateProps={this.emptyStateProps()}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: FeatureFlags.compactHeaderEnabled ? 'hidden' : 'enabled',
            }}
          />
        </div>
      </div>
    );
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      icon: SpotRecentBaseIcon,
      primaryMessage: Messages.recentsEmptyStatePrimary(),
      secondaryMessage: Messages.recentsEmptyStateSecondary(),
      onActionButton: this.onNoContentAction,
      actionButtonMessage: Messages.emptyStateCallToAction()
    };
  }

  private onNoContentAction = (): void => {
    Location.instance.setUrl(this.props.urls.exploreUrl());
  };
}
